// extracted by mini-css-extract-plugin
module.exports = {"description":"Scripts_description__3tXk8","annotatedCode":"Scripts_annotatedCode__2f3dw","titleNote":"Scripts_titleNote__M2lr5","warning":"Scripts_warning__1Vtqa"};